import { useMediaQuery } from "@sazka/utils/composables/use-media-query";
import { usePpWagerConfiguration } from "../../composables/use-wager-configuration";
import { computed } from "vue";
import { Lottery } from "@sazka/lotteries/js/models/lottery";

const mqMatches = useMediaQuery("screen and (max-width: 500px)");

export const useMiniRentaVariator = () => {
    const { config } = usePpWagerConfiguration();

    const isMiniRentaSmallBp = computed(() => {
        return mqMatches.value && config.lottery === Lottery.miniRenta;
    });

    return { isMiniRentaSmallBp };
};
